<template>
    <div>
        <v-date-picker
            is-range
            is-inline
            color="yellow"
            show-caps
            v-model='store.state.dates'
            :min-date='new Date()'
            is-expanded
            show-popover=false
        ></v-date-picker>

        <div class="selectTimeRentDate">
            <div class="h4 element-wrap mb-0 pt-0">Выберите время аренды:</div>

            <div class="element-wrap time-wrap">
                <div class="mb-16">
                    <div class="h6 color-text-grey text-uppercase mb-2">Начало</div>
                    <div class="timepicker-container">
                        <vue-timepicker :disabled="disabledTime" :class="{'no-chosen': store.state.dates.start && !store.state.timeStart.HH && !store.state.timeStart.mm}"
                                        hour-label="час" minute-label="мин"
                                        :hour-range="hourRange"
                                        :minute-interval="30" v-model="store.state.timeStart"
                                        placeholder="чч:мм"
                                        hide-clear-button
                                        auto-scroll
                                        close-on-complete></vue-timepicker>
                        <div v-if="disabledTime" class="time_disabled" v-b-popover.hover.focus.top="'Выберите срок аренды'"></div>
                    </div>

<!--                    <div class="d-flex align-items-center">-->
<!--                        <div class="time-inputs" :class="{'no-chosen': store.state.dates.start && !store.state.timeStart.label}">-->
<!--                            <div class="arrow arrow-top" @click="changeTime(1)"></div>-->
<!--                            <div>{{store.state.timeStart.label}}</div>-->
<!--                            <div class="arrow arrow-bottom" @click="changeTime(2)"></div>-->
<!--                        </div>-->

<!--                        <h3 class="font-700 pr-1 pl-1">:</h3>-->

<!--                        <div class="time-inputs"  :class="{'no-chosen': store.state.dates.start && !store.state.minStart.label}">-->
<!--                            <div class="arrow arrow-top" @click="changeMin(1)"></div>-->
<!--                            <div>{{store.state.minStart.label}}</div>-->
<!--                            <div class="arrow arrow-bottom"  @click="changeMin(1)"></div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>

                <div class="mb-16">
                    <div class="h6 color-text-grey text-uppercase mb-2">КОНЕЦ</div>
                    <div class="timepicker-container">
                        <vue-timepicker :disabled="disabledTime" :class="{'no-chosen': store.state.dates.start && !store.state.timeEnd.HH && !store.state.timeEnd.mm}"
                                        hour-label="час" minute-label="мин" :minute-interval="30" v-model="store.state.timeEnd"
                                        placeholder="чч:мм"
                                        :hour-range="hourEndRange"
                                        hide-clear-button
                                        auto-scroll
                                        close-on-complete>
                        </vue-timepicker>
                        <div v-if="disabledTime" class="time_disabled" v-b-popover.hover.focus.top="'Выберите срок аренды'"></div>
                    </div>


                    <!--                    <div class="d-flex align-items-center">-->
<!--                        <div class="time-inputs" :class="{'no-chosen': store.state.dates.start && !store.state.timeEnd.label}">-->
<!--                            <div class="arrow arrow-top" @click="changeTime(3)"></div>-->
<!--                            <div>{{store.state.timeEnd.label}}</div>-->
<!--                            <div class="arrow arrow-bottom" @click="changeTime(4)"></div>-->
<!--                        </div>-->

<!--                        <h3 class="font-700 pr-1 pl-1">:</h3>-->

<!--                        <div class="time-inputs" :class="{'no-chosen': store.state.dates.start && !store.state.minEnd.label}">-->
<!--                            <div class="arrow arrow-top" @click="changeMin(2)"></div>-->
<!--                            <div>{{store.state.minEnd.label}}</div>-->
<!--                            <div class="arrow arrow-bottom"  @click="changeMin(2)"></div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>

            </div>

            <div class="element-wrap count_days">
                <div class="h4 font-700 text-uppercase mb-0">Выбрано:</div>
                <div v-if="store.rate.value == 1 && store.rate.count !== 0">
                    {{store.rate.count}}
                    <span v-if="store.rate.count > 1">часа</span>
                    <span v-else>час</span>
                </div>
                <div v-if="store.rate.value == 2 && store.rate.count !== 0">
                    {{store.rate.count}} сут.
                </div>
                <div v-if="store.rate.count == 0" class="font-500">— сут.</div>
            </div>
        </div>

    </div>
</template>

<script>
    import moment from 'moment';
    import store from '../../../services/data';

    import Multiselect from 'vue-multiselect';
    import VueTimepicker from 'vue2-timepicker'

    moment.locale('ru');

    export default {
        components: { Multiselect, VueTimepicker },
        data() {
            return {
                moment: moment,
                store: store,
            }
        },

        created() {
            // this.store.setValueDatepicker();
            this.store.getItemBasketData();
        },

        computed: {
            displayDates() {
                const timeStart = {hour: 0, minute: 0, second: 0, millisecond: 0};
                const timeEnd = {hour: 0, minute: 0, second: 0, millisecond: 0};

                const from = moment(this.store.state.dates.start).set(timeStart).format('DD.MM.YY');
                const to = moment(this.store.state.dates.end).set(timeEnd).format('DD.MM.YY');

                if(this.store.state.dates.start && this.store.state.timeStart.HH && this.store.state.timeStart.mm) {
                    this.store.setItemlocalStorage('dateStart', moment(this.store.state.dates.start).set(timeStart).format());
                    this.store.setItemlocalStorage('timeHHStart',  this.store.state.timeStart.HH);
                    this.store.setItemlocalStorage('timeMinStart', this.store.state.timeStart.mm);
                }
                if(this.store.state.dates.end && this.store.state.timeEnd.HH && this.store.state.timeEnd.mm) {
                    this.store.setItemlocalStorage('dateEnd', moment(this.store.state.dates.end).set(timeStart).format());
                    this.store.setItemlocalStorage('timeHHEnd',  this.store.state.timeEnd.HH);
                    this.store.setItemlocalStorage('timeMinEnd', this.store.state.timeEnd.mm);
                }

                if (from === moment(new Date().setHours(0, 0, 0, 0)).set(timeStart).format('DD.MM.YY') && to === moment(new Date().setHours(0, 0, 0, 0)).set(timeStart).format('DD.MM.YY')) {
                    return 'Выберите дату...';
                } else {
                    return `${from} / ${to}`;
                }
            },

            disabledTime() {
                let data;
                if(this.store.state.dates.start && this.store.state.dates.end) data = false;
                if(!this.store.state.dates.start && !this.store.state.dates.end) data = true;
                return data;
            },

            hourRange() {
                let data = [[0, 23]];

                let currentDay =  moment(new Date()).format('DD.MM.YY');
                let dateStart =  moment(this.store.state.dates.start).format('DD.MM.YY');

                /* проверка если выбран сегодняшний день*/
                if(currentDay == dateStart) {
                    let timeStart = Number(moment(new Date()).format('HH')) + 1;
                    data = [[timeStart, 23]];
                    if(this.store.state.timeStart.HH && (this.store.state.timeStart.HH < timeStart)) {
                        this.store.state.timeStart.HH = null;
                        this.store.state.timeStart.mm = null;
                    }
                }
                return data;
            },

            hourEndRange() {
                let data = [[0, 23]];

                let currentDay =  moment(new Date()).format('DD.MM.YY');
                let dateStart =  moment(this.store.state.dates.start).format('DD.MM.YY');
                let dateEnd =  moment(this.store.state.dates.end).format('DD.MM.YY');

                /* проверка если выбран один день как день начала и конца аренды сегодня*/
                if(dateEnd == dateStart && dateEnd == currentDay) {
                    let timeEnd;
                    if(!this.store.state.timeStart.HH) timeEnd = Number(moment(new Date()).format('HH')) + 2;
                    if(this.store.state.timeStart.HH) timeEnd = Number(this.store.state.timeStart.HH) + 1;
                    data = [[timeEnd, 23]];
                    if(this.store.state.timeEnd.HH && (this.store.state.timeEnd.HH < timeEnd)) {
                        this.store.state.timeEnd.HH = null;
                        this.store.state.timeEnd.mm = null;
                    }
                }

                /* проверка если выбран один день как день начала и конца аренды НЕ сегодня*/
                if(dateEnd == dateStart && dateEnd != currentDay) {
                    let timeEnd = Number(this.store.state.timeStart.HH) + 1;
                    data = [[timeEnd, 23]];
                    if(this.store.state.timeEnd.HH && (this.store.state.timeEnd.HH < timeEnd)) {
                        this.store.state.timeEnd.HH = null;
                        this.store.state.timeEnd.mm = null;
                    }
                }
                return data;
            }
        },

        watch: {
            displayDates() {
                const timeStart = {hour: this.store.state.timeStart.HH, minute: this.store.state.timeStart.mm, second: 0, millisecond: 0};
                const timeEnd = {hour: this.store.state.timeEnd.value, minute: this.store.state.timeEnd.mm, second: 0, millisecond: 0};
                const start = moment(this.store.state.dates.start).set(timeStart);
                const end = moment(this.store.state.dates.end).set(timeEnd);

                const newDates = {
                    'from': start,
                    'to': end,
                };
                // this.store.setItemlocalStorage('chosen-dates', newDates);
                this.store.getItemBasketData();
                this.store.getCommonPrice();
            },

            'store.state.timeStart.HH'() {
                // let time = {
                //     'timeStart': this.store.state.timeStart,
                //     'timeEnd': this.store.state.timeEnd
                // };
                // this.store.setItemlocalStorage('chosen-time', time);
                this.store.getItemBasketData();
                this.store.getCommonPrice();
            },
            'store.state.timeEnd.HH'() {
                this.store.getItemBasketData();
                this.store.getCommonPrice();
            },
            'store.state.timeStart.mm'() {
                this.store.getItemBasketData();
                this.store.getCommonPrice();
            },
            'store.state.timeEnd.mm'() {
                this.store.getItemBasketData();
                this.store.getCommonPrice();
            },

        },

        methods: {

            //IT'S OLD FUNCTIONS FOR CHANGE TIME BY BUTTON
            changeTime(key) {
                let data = {value: null, label: null};
                if(key == 1 || key == 2) data = this.store.state.timeStart;
                if(key == 3 || key == 4) data = this.store.state.timeEnd;

                if(key == 1 || key == 3) {
                    if(data.label) {
                        if(data.value != 23) {
                            data.value = data.value + 1;
                            if (data.value < 10) data.label = '0' + data.value ;
                            else data.label = data.value.toString();
                        }
                        else data = {value: 0, label: '00'}
                    }
                    if(!data.label) data = {value: 0, label: '00'}
                }
                if(key == 2 || key == 4) {
                    if(data.label) {
                        if(data.label !== '00') {
                            data.value = data.value - 1;
                            if (data.value < 10) data.label = '0' + data.value ;
                            else data.label = data.value.toString();
                        }
                        else data = {value: 23, label: '23'}
                    }
                    if(!data.label) data = {value: 23, label: '23'}
                }

                if(key == 1 || key == 2) this.store.state.timeStart = data;
                if(key == 3 || key == 4) this.store.state.timeEnd = data;
            },

            changeMin(key) {
                let data = {value: null, label: null};
                if(key == 1) data = this.store.state.minStart;
                if(key == 2) data = this.store.state.minEnd;

                if(data.label) {
                    if(data.label == '00') {
                        data.label = '30';
                        data.value = 30;
                    }
                    else {
                        data.label = '00';
                        data.value = 0;
                    }
                }
                if(!data.label) data = {value: 0, label: '00'};

                if(key == 1) this.store.state.minStart = data;
                if(key == 2) this.store.state.minEnd = data;
            }
        }
    }
</script>
